'use strict';

export default (permissions = [], name) => {
  for (let i = 0; i < permissions.length; i++) {
    if (permissions[i] === name) {
      return true;
    }
  }
  return false;
};